import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk"; // v3+ = named export

import { authReducer } from "./reducers/authReducer";
import { studentReducer } from "./reducers/studentReducer";
import { staffReducer } from "./reducers/staffReducer";
import { attendanceReducer } from "./reducers/attendanceReducer";
import { feeReducer } from "./reducers/feeReducer";
import { examReducer } from "./reducers/examReducer";
import { homeworkReducer } from "./reducers/homeworkReducer";
import { noticeReducer } from "./reducers/noticeReducer";
import { salaryReducer } from "./reducers/salaryReducer";
import { inventoryReducer } from "./reducers/inventoryReducer";
import { hostelReducer } from "./reducers/hostelReducer";
import { transportReducer } from "./reducers/transportReducer";
import { timetableReducer } from "./reducers/timetableReducer";
import { libraryReducer } from "./reducers/libraryReducer";
import { metaReducer } from "./reducers/metaReducer";
import { leaveReducer } from "./reducers/leaveReducer";
import { studyMaterialReducer } from "./reducers/studyMaterialReducer";
import { canteenReducer } from "./reducers/canteenReducer";
import { sportsReducer } from "./reducers/sportsReducer";
import { feedbackReducer, holidayReducer, eventReducer } from "./reducers";
import {
  departmentReducer,
  qualificationReducer,
  religionReducer,
  casteReducer,
} from "./reducers";
import { roleReducer } from "./reducers";

const rootReducer = combineReducers({
  auth: authReducer,
  student: studentReducer,
  staff: staffReducer,
  attendance: attendanceReducer,
  fee: feeReducer,
  exam: examReducer,
  homework: homeworkReducer,
  notice: noticeReducer,
  salary: salaryReducer,
  inventory: inventoryReducer,
  hostel: hostelReducer,
  transport: transportReducer,
  timetable: timetableReducer,
  library: libraryReducer,
  meta: metaReducer,
  leave: leaveReducer,
  material: studyMaterialReducer,
  canteen: canteenReducer,
  sports: sportsReducer,
  feedback: feedbackReducer,
  holiday: holidayReducer,
  event: eventReducer,
  // ── Master data for Staff/Student dropdowns (Main/Sub + approval workflow) ──
  department: departmentReducer,
  qualification: qualificationReducer,
  religion: religionReducer,
  caste: casteReducer,
  role: roleReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));
export default store;
